import { render } from "./SiteFooter.vue?vue&type=template&id=6d7516c4&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=6d7516c4&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7516c4"]])

export default __exports__